<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="8" :sceneType="sceneType"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <list></list>
      </el-main>
  </el-container>
</template>

<script>
import list from './components/list'
import leftMenu from './components/leftMenu'
export default {
  name: "cIndex",
  components: {
    list, leftMenu
  },
  data() {
    return {
      sceneType: this.$route.query.sceneType
    }
  },
  created() {
    if(this.$route.query.account){
      sessionStorage.account = this.$route.query.account;
    }
    if(this.$route.query.token){
      sessionStorage.token = this.$route.query.token;
    } 
  },
  methods: {
  }
}
</script>

<style lang="less">
@import '../style.less';
</style>
